import React, { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'
import { Animate } from './animate'
import { CroppedText } from './cropped-text'
import { headEnText, headJaText } from '../styles/text-styles'

const Outer = styled.div`

`

const En = styled.div`
  ${headEnText}
`

const Ja = styled.div`
  ${headJaText}
  margin-top: 0.4375rem;
`

type SectionHeadProps = {
  en: ReactNode,
  ja: ReactNode
}
export const SectionHead: FunctionComponent<SectionHeadProps> = ({en, ja}) => {
  return <Outer>
    <En>
      {en}
    </En>
    <Ja>
      {ja}
    </Ja>
  </Outer>
}